<div class="d-flex">
  <app-components-navbar></app-components-navbar>
  @if (isDeveloperMode) {
    <div class="capsule">
      <app-navtabs [type]="'setting'"></app-navtabs>
    </div>
  } @else {
    @if (!isDeveloperMode) {
      <div class="capsule main">
        <app-settings></app-settings>
      </div>
    }
  }
</div>